/**
 * /menu-categories API 응답(Category[])을 LNB용 CategoryItem[] 형식으로 변환
 */ export const convertCategoriesToLnbItems = (categories)=>{
    return categories.map((category)=>({
            categoryId: category.id,
            title: category.name,
            productId: "",
            items: category.items ? convertCategoriesToLnbItems(category.items) : undefined
        }));
};
/**
 * 카테고리 ID로 해당 depth의 최상위 카테고리(depthItem) 찾기
 */ export const findDepthItemByCategoryId = (depthItems, categoryId)=>{
    if (!categoryId || !depthItems) return null;
    for (const depthItem of depthItems){
        // 현재 depthItem이나 하위에 categoryId가 있는지 확인
        if (hasCategoryId(depthItem, categoryId)) {
            return depthItem;
        }
    }
    return null;
};
/**
 * 재귀적으로 카테고리 ID가 존재하는지 확인
 */ const hasCategoryId = (category, categoryId)=>{
    if (category.id === categoryId) return true;
    if (category.items) {
        return category.items.some((item)=>hasCategoryId(item, categoryId));
    }
    return false;
};
/**
 * 카테고리 ID로 현재 경로(breadcrumb) 찾기
 */ export const findCategoryPath = (depthItem, categoryId)=>{
    if (!depthItem || !categoryId) return [];
    const path = [];
    findPathRecursive(depthItem, categoryId, path);
    return path;
};
const findPathRecursive = (category, targetId, path)=>{
    if (category.id === targetId) {
        path.push({
            title: category.name
        });
        return true;
    }
    if (category.items) {
        for (const item of category.items){
            if (findPathRecursive(item, targetId, path)) {
                path.unshift({
                    title: category.name,
                    link: "/categories?id=".concat(category.id)
                });
                return true;
            }
        }
    }
    return false;
};
/**
 * 카테고리 ID로 해당 카테고리 객체 찾기
 */ export const findCategoryById = (categories, categoryId)=>{
    for (const category of categories){
        if (category.id === categoryId) return category;
        if (category.items) {
            const found = findCategoryById(category.items, categoryId);
            if (found) return found;
        }
    }
    return null;
};
/**
 * 선택된 카테고리가 마지막 depth인지 확인
 */ export const checkIsLastDepth = (depthItem, categoryId)=>{
    if (!depthItem || !categoryId) return false;
    const allCategories = depthItem.items || [
        depthItem
    ];
    const category = findCategoryById(allCategories, categoryId);
    return category ? !category.items || category.items.length === 0 : false;
};
/**
 * depthItem에서 첫 번째 유효한 카테고리 ID 찾기
 */ export const findFirstCategoryId = (depthItem)=>{
    if (depthItem.items && depthItem.items.length > 0) {
        return findFirstCategoryIdRecursive(depthItem.items);
    }
    return depthItem.id;
};
const findFirstCategoryIdRecursive = (categories)=>{
    for (const category of categories){
        // 하위가 있으면 하위의 첫 번째로 계속 들어감
        if (category.items && category.items.length > 0) {
            const found = findFirstCategoryIdRecursive(category.items);
            if (found) return found;
        } else {
            // 하위가 없으면 현재 ID 반환 (마지막 depth)
            return category.id;
        }
    }
    return null;
};
